import { array, object, string } from 'yup';

import { ICheckProjectCodeDTO } from '@interfaces/portal/dto/projectManagementDTO';

import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_10_LENGTH, MAX_80_LENGTH, MAX_1000_LENGTH } from '@constants/validationMessages';

interface IGetSchema {
	handleCheckProjectCode: (data: ICheckProjectCodeDTO) => void;
	organizationId: string;
	isEditMode: boolean;
}

export const getSchema = ({
	handleCheckProjectCode,
	organizationId,
	isEditMode,
}: IGetSchema) => object({
	projectName: string()
		.trim()
		.default('')
		.max(MAX_80_LENGTH, getMaxLengthErrMsg('Project Name', MAX_80_LENGTH))
		.required(validationErrMessages.projectName),
	projectCode: string()
		.trim()
		.default('')
		.max(MAX_10_LENGTH, getMaxLengthErrMsg('Project Code', MAX_10_LENGTH))
		.required(validationErrMessages.projectCode)
		.test('code',
			async (value, context) => {
				if (!value) return false;

				if (isEditMode) return true;

				try {
					await handleCheckProjectCode({ code: value, organizationId });

					return true;
				} catch (err: any) {
					if (err?.errors?.length && err.errors[0].message) {
						return context.createError({ message: err.errors[0].message });
					}

					return context.createError({ message: 'Project code must be unique' });
				}
			},
		),
	status: object()
		.nullable()
		.required(validationErrMessages.status),
	workflow: object()
		.nullable()
		.required(validationErrMessages.workflow),
	description: string()
		.trim()
		.default('')
		.max(MAX_1000_LENGTH, getMaxLengthErrMsg('Project Description', MAX_1000_LENGTH)),
	admins: array().nullable(),
	members: array().nullable(),
});
